// 正则校验的正则表达式，这里注意正则表达式中的‘\’要使用‘\\’转义
const _pattern = {
  letterFirst: '^[A-Za-z][A-Za-z0-9-_]*$',
  name: '^[A-Za-z0-9-_]+$',
  nameOrPath: '^[A-Za-z0-9-_/]+$',
  tel: '^1[2-9]\\d{0,}$',
  email: '^\\w+([-+.]\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*$',
  pwd: '^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)]|[\\(\\)])+$)([^(0-9a-zA-Z)]|[\\(\\)]|[a-z]|[A-Z]|[0-9]){8,}$',
  IP: '^(?=(\\b|\\D))(((\\d{1,2})|(1\\d{1,2})|(2[0-4]\\d)|(25[0-5]))\\.){3}((\\d{1,2})|(1\\d{1,2})|(2[0-4]\\d)|(25[0-5]))(?=(\\b|\\D))$',
  IDCard: '(^\\d{15}$)|(^\\d{17}([0-9]|X)$)',
  num: '^[0-9]+$',
  url: '^((([Hh][Tt])|(Ff))[Tt][Pp][Ss]?):\\/\\/[\\w\\-]+(\\.[\\w\\-]+)+([\\w\\-\\.,@?^=%&:\\/~\\+#]*[\\w\\-\\@?^=%&\\/~\\+#])?$',
};

// 对应正则表达式的提示信息
const _patternMsg = {
  letterFirst: '字母开头，由数字、字母、横线、下划线组成',
  name: '由数字、字母、横线、下划线组成',
  nameOrPath: '由数字、字母、横线、下划线、右斜杠组成',
  tel: '非正确的号码',
  email: '非正确的邮箱地址',
  pwd: '密码至少由8位包含字母、数字、特殊字符两种组合',
  IP: '非正确IP地址',
  IDCard: '非正确身份证号码',
  num: '非正确数字',
  url: '非URL地址',
};

// 根据使用的正则返回对应的正则和信息对象
const formRulePattern = (type) => {
  return {
    pattern: new RegExp(_pattern[type]),
    message: _patternMsg[type],
  };
};

export default formRulePattern;
